import { Stack } from '@mui/material'
import { t } from 'i18next'
import { useEffect, useRef, useState } from 'react'

import Can from '../../Layout/Can/Can.jsx'
import Filter from '../../Layout/Dialogs/Filter.jsx'
import Count from '../../Shared/Components/Count.jsx'
import { OrganizationsFilter } from '../../Shared/Filters/Fields/index.js'
import FiltersOthers from './Filters/Others.jsx'

const Filters = ({ filters, onChange, itemsCount }) => {
  const [selectedOrganizations, setSelectedOrganizations] = useState(false)
  const [selectedOther, setSelectedOther] = useState(false)
  const [announcementUpdatePage, setAnnouncementUpdatePage] = useState('')
  const shouldAnnounceUpdatePage = useRef(false)
  const previousItemsCount = useRef(itemsCount)

  const handleOrganizationsChange = (data) => {
    setSelectedOrganizations(true)
    onChange({
      ...filters,
      ...data
    })
  }

  const handleOthersFiltersChange = (data) => {
    setSelectedOther(true)
    onChange({
      ...filters,
      ...data
    })
  }

  const handleOnDeleteOrganizations = () => {
    setSelectedOrganizations(false)
    onChange({
      ...filters,
      organizationKeys: [],
      searchInSubOrganizations: false
    })
    shouldAnnounceUpdatePage.current = true
  }

  const handleOnDeleteOther = () => {
    setSelectedOther(false)
    onChange({
      ...filters,
      status: [],
      triggerTypes: []
    })
    shouldAnnounceUpdatePage.current = true
  }

  const handleFilterClose = () => {
    shouldAnnounceUpdatePage.current = true
    announceUpdatePage()
  }

  const getAnnouncementMessage = () => {
    if (itemsCount === 0) {
      return t('filters.accessibility.noItemsFound')
    } else if (itemsCount === 1) {
      return t('filters.accessibility.oneItemFound')
    } else {
      return t('filters.accessibility.itemsFound', { count: itemsCount })
    }
  }

  const announceUpdatePage = () => {
    setAnnouncementUpdatePage('')

    setTimeout(() => {
      setAnnouncementUpdatePage(getAnnouncementMessage())
    }, 100)
  }

  useEffect(() => {
    if (shouldAnnounceUpdatePage.current && previousItemsCount.current !== itemsCount) {
      announceUpdatePage()
      shouldAnnounceUpdatePage.current = false
    }
    previousItemsCount.current = itemsCount
  }, [itemsCount])

  const filterUnits = [
    {
      label: t('filters.devices.organizations.label'),
      id: 'chip-filters-events-organizations',
      selected: selectedOrganizations,
      onDelete: handleOnDeleteOrganizations,
      onClose: handleFilterClose,
      content: (
        <OrganizationsFilter
          onChange={handleOrganizationsChange}
          filters={filters}
        />
      ),
      count: <Count itemsCount={itemsCount} />
    },
    {
      label: t('common.filters.other'),
      id: 'chip-filters-events-other',
      selected: selectedOther,
      onDelete: handleOnDeleteOther,
      onClose: handleFilterClose,
      content: (
        <FiltersOthers
          onChange={handleOthersFiltersChange}
          filters={filters}
        />
      ),
      count: <Count itemsCount={itemsCount} />
    }
  ]

  return (
    <>
      {/* Live region per annunci screen reader */}
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '-10000px',
          width: '1px',
          height: '1px',
          overflow: 'hidden'
        }}
      >
        {announcementUpdatePage}
      </div>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={2}
      >
        {[...filterUnits].map((e, i) => (
          <Can
            action="automations_r"
            key={`device-filter-${i}`}
          >
            <Filter
              key={`device-filter-${i}`}
              id={e.id}
              onClick={e.onClick}
              onDelete={e.onDelete}
              onClose={e.onClose}
              selected={e.selected}
              title={e.label}
              hidden={e.hidden || false}
              content={e.content}
              count={e.count}
            />
          </Can>
        ))}
      </Stack>
    </>
  )
}

export default Filters
